import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { getStorageData, removeStorageData } from "framework/src/Utilities";

// Customizable Area Start
import { InfoType } from "../../../components/src/CustomInfoDialog.web";
import { scrollToTop } from "../../../components/src/utils";

enum PlansNameEnum {
  Free= "Free",
  Monthly="Monthly",
  Yearly="Yearly"
}

export interface IFeature {
  text: string
  available: boolean
}

interface IOrderDetails {
  id: string
  type: string
  attributes: {
    id: number
    order_number: string
    status: string
    total: number
    gst: number
    sub_total: number
    valid_date: string
    active_plan: boolean
    order_date: string
    auto_renewal: boolean
    subscription: {
        id: number
        name: string
        price: string
    },
    account: {
        id: number
        full_name: string
        email: string
    }
  }
}

export interface ISubscriptionPlan {
  id: string
  type: string
  attributes: {
    name: PlansNameEnum
    price: number
    is_plan_used: boolean
  }
}

interface ISubscriptionPlansSuccessResponse {
  data: ISubscriptionPlan[]
}

interface IUpdateFreePlanSuccessResponse {
  message: string
  order_details: { data: IOrderDetails }
}

interface IUpdatePlanSuccessResponse {
  data: IOrderDetails
}

interface IUpdatePlanErrorResponse {
  error: string
}

interface IActivePlanSuccessResponse {
  data: IOrderDetails
}

interface IActivePlanErrorResponse {
  error: string
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
    navigation: any;
    id: string;
    // Customizable Area Start
    // Customizable Area End
}

interface S {
  // Customizable Area Start
  isLoading: boolean
  isChangingPlan: boolean
  isUpgradeDialog: boolean;
  isInfoDialog: boolean;
  infoType: InfoType
  infoMessage: string
  infoDescription: string | undefined
  activePlan: IOrderDetails | null
  upgradingPlanId: string
  subscriptionPlans: ISubscriptionPlan[]
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class SubscriptionPlansController extends BlockComponent<
  Props,
  S,
  SS
> {
    // Customizable Area Start
    getActivePlanApiCallId: string = ""
    subscriptionsPlansApiCallId: string = ""
    updateSubscriptionPlanApiCallId: string = ""
    // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
       isLoading: false,
       isChangingPlan: false,
       isUpgradeDialog: false,
       activePlan: null,
       isInfoDialog: false,
       infoType: "success",
       infoMessage: "",
       infoDescription: "",
       upgradingPlanId: "",
       subscriptionPlans: []
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.handlePageLoadApiCalls()
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCalId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    if(apiRequestCalId === this.subscriptionsPlansApiCallId) {
      this.handleSubscriptionPlansListingResponse(responseJson)
    }

    if(apiRequestCalId === this.updateSubscriptionPlanApiCallId) {
      this.handleUpdateSubscriptionResponse(responseJson)
    }

    if(apiRequestCalId === this.getActivePlanApiCallId) {
      this.handleActiveSubscriptionResponse(responseJson)
    }
    // Customizable Area End
  }
  
  // Customizable Area Start
  handlePageLoadApiCalls = async () => {
    scrollToTop()
    const isAuthenticated = await this.isAuthenticated()
    this.subscriptionPlansApi()
    if(isAuthenticated) {
      this.getActivePlanApi()
    }
  }

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  }

  isAuthenticated = async () => {
    return !!await getStorageData(configJSON.TOKEN)
  }

  handleReviewOrderRedirection = (order: IOrderDetails) => {
    const message = new Message(getName(MessageEnum.NavigationMessage));
    message.addData(getName(MessageEnum.NavigationTargetMessage), "OrderReview");

    message.addData(getName(MessageEnum.NavigationPropsMessage), this.props);

    const raiseMessage: Message = new Message(
      getName(MessageEnum.NavigationPayLoadMessage)
    );
    raiseMessage.addData(getName(MessageEnum.SessionResponseData), { order });
    message.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);

    this.send(message);
  }

  handleOpenInfoDialog = (
    infoType: InfoType,
    infoMessage: string,
    infoDescription?: string
  ) => {
    this.setState({
      isInfoDialog: true,
      infoType,
      infoMessage,
      infoDescription,
    })
  }

  handleCloseInfoDialog = () => {
    this.setState({ isInfoDialog: false }, () => {
      this.setState({ infoMessage: "", infoDescription: "" })
    });
  };

  handleCloseUpgradeDialog = () => {
    this.setState({ isUpgradeDialog: false });
  };

  handleChangePlan = async (planId: string, planName: PlansNameEnum, isActivePlan: boolean) => {
    const isAuthenticated = await this.isAuthenticated()

    if(!isAuthenticated) {
      this.handlePageRedirection("EmailAccountLoginBlock")
    }

    if(isActivePlan) {
      return
    }

    if(planName === PlansNameEnum.Free) {
      this.handleUpgradePlanApiCall(planId)
    } else {
      this.setState({ isUpgradeDialog: true, upgradingPlanId: planId })
    }
  }

  handleUpgradePlanApiCall = (planId: string) => {
    const query =  `subscription_id=${planId}`
    this.setState({ isUpgradeDialog: false })
    this.changeSubscriptionPlanApi(query)
  }

  getActivePlanApi = async () => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN)

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getActivePlanApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.activePlanApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  subscriptionPlansApi = async () => {
    this.setState({ isLoading: true })
    const token = await getStorageData(configJSON.TOKEN) || ""

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.subscriptionsPlansApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.subscriptionPlanApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  changeSubscriptionPlanApi = async (query: string) => {
    this.setState({ isChangingPlan: true })
    const token = await getStorageData(configJSON.TOKEN)
    const endpoint = `${configJSON.updateSubscriptionPlanApiEndpoint}?${query}`

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateSubscriptionPlanApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleSubscriptionPlansListingResponse = (
    responseJson: ISubscriptionPlansSuccessResponse
  ) => {
    if ("data" in responseJson) {
      this.setState({
        isLoading: false,
        subscriptionPlans: responseJson.data,
      })
    } else {
      this.setState({
        isLoading: false,
      })
    }
  }

  handleUpdateSubscriptionResponse = async (
    responseJson: IUpdatePlanSuccessResponse | IUpdateFreePlanSuccessResponse | IUpdatePlanErrorResponse
  ) => {
    if ("order_details" in responseJson) {
      const { message, order_details } = responseJson
      const { data: {
        attributes: {
          subscription: {
            name
          }
        }
      } } = order_details

      if (name === PlansNameEnum.Free) {
        this.setState({
          isChangingPlan: false,
          isUpgradeDialog: false,
          activePlan: order_details.data,
        })
        this.handleOpenInfoDialog("success", configJSON.congratulationsText, message)
      }
    } else if ("data" in responseJson) {
      this.handleReviewOrderRedirection(responseJson.data)
    } else {
      this.setState({ isChangingPlan: false })
      this.handleOpenInfoDialog("error", "")
    }
  }  

  handleActiveSubscriptionResponse = (
    responseJson: IActivePlanSuccessResponse | IActivePlanErrorResponse
  ) => {
    if ("data" in responseJson) {
      this.setState({ activePlan: responseJson.data, isLoading: false })
    } else {
      this.setState({ isLoading: false })
    }
  }
  // Customizable Area End
}